import { render, staticRenderFns } from "./recipients-create-edit-form.vue?vue&type=template&id=0082911e&scoped=true&"
import script from "./recipients-create-edit-form.vue?vue&type=script&lang=js&"
export * from "./recipients-create-edit-form.vue?vue&type=script&lang=js&"
import style0 from "./recipients-create-edit-form.vue?vue&type=style&index=0&id=0082911e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0082911e",
  null
  
)

export default component.exports